import React, { useState } from "react";
import { useToast } from "../../../../context/ToastContext";
import MemberSelect from "../../../shared/MemberSelect";

const MinorDetailsForm = ({
  householdData,
  fieldData,
  entityId,
  onSave,
  onSaveAndExit,
  saving,
  nextLabel,
}) => {
  const { toast } = useToast();
  const account = fieldData || {};
  const members = householdData?.members || [];

  const existingOwners = (Array.isArray(account.owners_info) ? account.owners_info : [])
    .filter((o) => o && typeof o === "object" && o.id);
  const needMinor = existingOwners.length < 2;

  const [memberId, setMemberId] = useState("");

  if (!needMinor) {
    return (
      <div className="text-center py-6 text-gray-500">
        <p className="text-sm">The minor has been added to this account.</p>
      </div>
    );
  }

  const validate = () => {
    if (!memberId) return "Please select the minor.";
    if (existingOwners.some((o) => String(o.id) === String(memberId)))
      return "The selected member is already an owner of this account.";
    return null;
  };

  const handleSubmit = (saveCallback) => {
    const err = validate();
    if (err) {
      toast.error(err);
      return;
    }
    const allOwners = [...existingOwners, { id: memberId, type: "primary" }];
    const evenShare = Math.floor(100 / allOwners.length);
    const owners_info = allOwners.map((owner, idx) => ({
      ...owner,
      share: idx === allOwners.length - 1
        ? 100 - evenShare * (allOwners.length - 1)
        : evenShare,
    }));
    saveCallback({ accounts: { [entityId]: { owners_info } } });
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-lg font-semibold text-gray-900">Missing Information</h2>
        <span className="text-sm text-red-500 font-medium">
          ● 1 Required field missing
        </span>
      </div>

      <p className="text-sm text-gray-600 mb-4">
        A UTMA/UGMA account requires the minor as the second account owner.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-5">
        <MemberSelect
          label="Minor"
          required
          members={members.filter(
            (m) => !existingOwners.some((o) => String(o.id) === String(m.id)),
          )}
          value={memberId}
          onChange={setMemberId}
        />
      </div>
      <p className="text-xs text-gray-500 mt-3">
        If the minor isn't listed, add them as a household member first.
      </p>

      <div className="flex items-center justify-between mt-8 pt-6 border-t border-gray-200">
        <button onClick={() => handleSubmit(onSaveAndExit)} disabled={saving} className="px-6 py-2.5 rounded-lg text-sm font-medium border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 transition-colors disabled:opacity-50">
          Save & Exit
        </button>
        <button onClick={() => handleSubmit(onSave)} disabled={saving} className="px-6 py-2.5 rounded-lg text-sm font-medium bg-emerald-500 text-white hover:bg-emerald-600 transition-colors disabled:opacity-50 flex items-center gap-2">
          {saving && <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" /></svg>}
          {nextLabel || "Save & Next →"}
        </button>
      </div>
    </div>
  );
};

export default MinorDetailsForm;
